/* src/app/_shared/components/clients-list-skeleton/clients-list-skeleton.component.scss */
app-item .skeleton-container {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
}
app-item .skeleton-container .icon-skeleton {
  width: 34px;
  height: 34px;
  margin-right: var(--space-right);
  border-radius: var(--radius);
}
app-item .skeleton-container .text-container .title-skeleton {
  width: 100%;
  height: 16px;
  margin-bottom: calc(var(--space-bottom) / 2);
}
app-item .skeleton-container .text-container .subtitle-skeleton {
  max-width: 50%;
  width: 250px;
  height: 14px;
}
/*# sourceMappingURL=clients-list-skeleton.component.css.map */
